import { render, staticRenderFns } from "./MatchHSAndGSRPReferral.vue?vue&type=template&id=7c1ee790&"
import script from "./MatchHSAndGSRPReferral.vue?vue&type=script&lang=ts&"
export * from "./MatchHSAndGSRPReferral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports